import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'df-public-tactics',
  templateUrl: './public-tactics.component.html',
  styleUrls: ['./public-tactics.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicTacticsComponent {}
